import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'
import { DaydicTypesIconNames } from 'src/app/shared/enums/enums'
import { Note } from 'src/app/shared/models/main/note'

export interface GroupNodeData {
  note: Note
}

@Component({
  selector: 'ddc-canvas-node-note',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
  ],
  templateUrl: './note-node.component.html',
  styleUrls: ['./note-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasNoteNodeComponent implements NgDiagramGroupNodeTemplate<GroupNodeData> {
  node = input.required<GroupNode<GroupNodeData>>()
  title = signal<string>('Note')
  icon = signal<string>(DaydicTypesIconNames.NOTE)
}
